import React from "react";
import {ControlLabel, FormControl, Radio, Button, Modal, Alert} from "react-bootstrap";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import util from "./../../lib/util.js";
import immutable from "immutable";
import moment from "moment";

import TaskDurationList from "./task-duration-list.jsx";
import SpecialBillForm from "./../shared/specialbill-form2.jsx";
import TimecardLineCopy from "./../shared/tc-line-copy.jsx";

export default class TaskDurationGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecardLineId: null,
            timecardLineDetailId: null,
            taskDurationList: null,
            timecardDetail: null,
            showDurationList: false,
            showTcDetailForm: false,
            showDialogErrorMessage: false,
            dialogErrorMessage: [],
            selectedDayId: null,
            selectedTaskCode: null,
            totalHours: 0,
            totalHoursDaily: [],
            specialBillForm: null,
            saveWorkErrors: null,
            titleTcDetailForm: "Log Work",
            disablePlacementTask: false
        };

        this.onDurationClicked = this.onDurationClicked.bind(this);
        this.onOpenTcLineCopy = this.onOpenTcLineCopy.bind(this);
        this.onSaveTcLineCopy = this.onSaveTcLineCopy.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDeletedItem = this.onDeletedItem.bind(this);
        this.onPlacementTaskChanged = this.onPlacementTaskChanged.bind(this);
        this.onTaskSelected = this.onTaskSelected.bind(this);

        this.loadTaskDurationList = this.loadTaskDurationList.bind(this);
        this.openTcDetailForm = this.openTcDetailForm.bind(this);
        this.closeTcDetailForm = this.closeTcDetailForm.bind(this);
        this.saveTcDetailForm = this.saveTcDetailForm.bind(this);
        this.getTaskIdByCode = this.getTaskIdByCode.bind(this);
        this.mapPlacementTaskDetails = this.mapPlacementTaskDetails.bind(this);
        this.getItemLink = this.getItemLink.bind(this);
        this.updateTotal = this.updateTotal.bind(this);
    }

    onDurationClicked(dayId, placementTaskCode, placementTaskId) {
        let self = this;
        this.setState({ 
                selectedDayId: dayId, 
                selectedTaskCode: placementTaskCode
            },
            function() {
                if (self.state.selectedDayId == null || self.state.selectedTaskCode == null) {
                    self.openTcDetailForm(null);
                } else {
                    self.loadTaskDurationList(self.props.timecardId, self.state.selectedDayId, self.state.selectedTaskCode, true);
                }
        });
    }

    onOpenTcLineCopy() {
        this.refs.tcLineCopy.open();
    }

    onSaveTcLineCopy(result) {
        this.refs.tcLineCopy.close();
        if (this.props.onUpdateSummary) 
            this.props.onUpdateSummary(result.data.timecardId);
    }

    onPlacementTaskChanged(taskCode) {
        this.state.specialBillForm.updateList(taskCode);
        this.state.timecardDetail.placementTaskCode = taskCode;
    }

    onTaskSelected(taskCode) {
        if (this.props.onAddTaskToSummary)
            this.props.onAddTaskToSummary(taskCode);
    }

    onCancel() {
        this.setState({
            timecardDetail: null, 
            showDurationList: false, 
            showTcDetailForm: false,
            showDialogErrorMessage: false,
            dialogErrorMessage: []
        });
    }

    onDeletedItem(dayId, placementTaskCode) {
        this.loadTaskDurationList(this.props.timecardId, dayId, placementTaskCode, false);
        if (this.props.onUpdateSummary)
            this.props.onUpdateSummary(this.props.timecardId);
    }

    loadTaskDurationList(timecardId, dayId, placementTaskCode, openDialogIfEmpty) {
        let self = this;
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        ajax.api().get("get-task-duration-list/" + timecardId + "/" + dayId + "/" + placementTaskCode)
            .then(function(res) {
                if (res != null && res.data != null) {
                    self.setState({ taskDurationList: res.data, showDurationList: true});
                } else if (openDialogIfEmpty) {
                    self.openTcDetailForm(null);
                } else {
                    self.setState({showDurationList: false});
                }
                context.message({show:false});
            })
            .catch(function(err) {
                let data = err.response? err.response.data: err;
                context.message({
                    show: true,
                    type:"error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    openTcDetailForm(timecardDetailId) {
        let dayIndex = this.state.selectedDayId-1;
        if (dayIndex == null || dayIndex < 0) {
            let now = moment();
            for(let i=0; i<this.props.weekDays.length; i++) {
                let weekDate = moment(this.props.weekDays[i]);
                if (weekDate.format("M/D/YYYY") == now.format("M/D/YYYY")) {
                    dayIndex = i;
                    break;
                }
            }
        }
        
        let self = this;    
        if (timecardDetailId == null) {
            if (self.props.tasks == null || self.props.tasks == undefined || self.props.tasks.length == 0) {
                context.message({
                    show: true,
                    type: "error",
                    message: "Placement tasks are missing. Please contact Help Desk",
                    buttons: "ok"
                });
                return false;
            }
            self.setState({
                titleTcDetailForm: "Log Work",
                showTcDetailForm: true, 
                showDurationList: false,  
                disablePlacementTask: false,
                taskDurationList: null,
                timecardLineDetailId: null,
                timecardDetail: {
                    timecardLineDetailId: null,
                    workDate: self.props.weekDays[dayIndex], 
                    placementTaskCode: self.state.selectedTaskCode
                }
            }, function() { this.onPlacementTaskChanged(self.state.selectedTaskCode); });
        } else {
            context.message({show:true, type: "loading", message:"Loading. Please wait..."});
            ajax.api().get("get-timecardlinedetail/" + timecardDetailId)
                .then(function(res) {
                    if (res != null && res.data != null) {
                        self.setState({
                            titleTcDetailForm: "Edit Log",
                            showTcDetailForm: true, 
                            showDurationList: false, 
                            disablePlacementTask: (self.props.tasks.map(t => t.taskCode).indexOf(res.data.placementTaskCode) < 0),
                            taskDurationList: null,
                            timecardLineDetailId: res.data.timecardDetailLineId,
                            timecardDetail: {
                                timecardLineDetailId: res.data.timecardDetailLineId,
                                placementTaskCode: res.data.placementTaskCode,
                                workDate: res.data.workDate,
                                workTime: res.data.workTime,
                                comment: res.data.comment
                            }
                        }, function() { this.onPlacementTaskChanged(res.data.placementTaskCode); });
                    }
                    context.message({show:false});
                })
                .catch(function(err) {
                    let data = err.response? err.response.data: err;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                });
        }
    } 

    closeTcDetailForm() {
        this.setState({ showTcDetailForm: false, showDialogErrorMessage: false });
    }

    saveTcDetailForm(timecardLineDetail) {  
        const self = this;
        const errors = this.validateTcDetail(timecardLineDetail);
        const clone = immutable.fromJS(this.state).toJS();
        clone.showDialogErrorMessage = errors.length > 0;
        clone.dialogErrorMessage = errors
        if (clone.showDialogErrorMessage) {
            this.setState(clone);
        } else {
            context.message({
                show: true,
                type:"loading",
                message: "Saving work time. Please wait..."            
            });

            let url = 'add-durationtc';
            if (timecardLineDetail.timecardLineDetailId != null && timecardLineDetail.timecardLineDetailId > 0)
                url = 'update-durationtc/' + timecardLineDetail.timecardLineDetailId;
            
            let ajaxCall = null;
            if (url == 'add-durationtc')
                ajaxCall = ajax.api().post(url, timecardLineDetail);
            else
                ajaxCall = ajax.api().put(url, timecardLineDetail);

            ajaxCall
                .then(function(res){
                    context.message({
                        show: false
                    }); 
                
                    let timecardId = self.props.timecardId
                    if (timecardId <= 0)
                        timecardId = res.data.timecardId;

                    self.closeTcDetailForm();
                    if (self.props.onUpdateSummary) 
                        self.props.onUpdateSummary(timecardId);
                })
                .catch(function(err) {
                    context.message({
                        show: false
                    });              
                    
                    clone.showDialogErrorMessage = true;
                    clone.dialogErrorMessage = [];

                    let data = err.response? err.response.data: err;
                    if (data.ClassName === "ActionPortal.ValidationException") {               
                        for(let key in data.Data.summary.validationResults) {                      
                            clone.dialogErrorMessage.push(data.Data.summary.validationResults[key]);
                        }
                    } else {
                        const msg = data.exceptionMessage || data.message;
                        clone.dialogErrorMessage = [msg];
                    }

                    self.setState(clone);
                });
        }
    }

    validateTcDetail(timecardLineDetail) {
        let msg = [];

        if (!timecardLineDetail.placementTaskCode.trim()) {
            msg.push("Task is required");
        }

        if (this.state.specialBillForm) {
            let errorMsg = this.state.specialBillForm.validate();
            if (errorMsg != null)
                msg.push(errorMsg);
        }
  
        if (!timecardLineDetail.workDate.trim()) {
            msg.push("Date is required");
        }

        if (isNaN(timecardLineDetail.workTime) || timecardLineDetail.workTime <= 0.0) {
            msg.push("Invalid Hours");
        }

        if (this.props.editRequiresReason && !timecardLineDetail.changeReason.trim()) {
            msg.push("Reason is required");
        }

        return msg;
    }

    getTaskIdByCode(taskCode) {
        let vm = this.props.vm;
        for(let i=0; i<vm.length; i++) {
            if (vm[i].taskCode == taskCode)
                return vm[i].taskId.toString();
        }

        return '';
    }

    mapPlacementTaskDetails(details) {
        if (!details)
            return null;

        return details.map(td => {
            return {
                placementTaskDetailId: td.placementTaskDetailId,
                placementTaskId: td.placementTaskId,
                sequenceId: td.sequenceId,
                taskCode: td.taskCode,
                taskValue: td.taskValue,
                required: td.required,
                timecardLineDetailId: td.timecardLineDetailId,
                specialBillId: td.specialBillId,
                specialBillValue: td.specialBillValue
            }
        });
    }

    updateTotal() {
        let vm = this.props.vm;
        let sum = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];  // [Sun, Mon... Sat]
        
        sum[0] = vm.reduce((init, val) => init + val.durationDay1, 0);
        sum[1] = vm.reduce((init, val) => init + val.durationDay2, 0);
        sum[2] = vm.reduce((init, val) => init + val.durationDay3, 0);
        sum[3] = vm.reduce((init, val) => init + val.durationDay4, 0);
        sum[4] = vm.reduce((init, val) => init + val.durationDay5, 0);
        sum[5] = vm.reduce((init, val) => init + val.durationDay6, 0);
        sum[6] = vm.reduce((init, val) => init + val.durationDay7, 0);

        // this is intentional to prevent re-render
        this.state.totalHoursDaily = sum;
        this.state.totalHours = sum.reduce((init, val) => init + val, 0);
    }

    getItemLink(dayId, taskCode, taskId, duration) {
        const allowEdit = this.props.allowEdit;

        if ((allowEdit && (taskId > 0 || duration > 0)) || (!allowEdit && duration > 0))
            return <a href="#" onClick={() => this.onDurationClicked(dayId, taskCode, taskId)}>{duration.toFixed(2)}</a>;

        return <a disabled="disabled" style={{cursor:"text"}}>{duration.toFixed(2)}</a>;
    }

    render() {
        const isMobile = util.isMobile();
        const hideTotalHours = this.props.hideTotalHours === true;
        const hideTotalHoursDaily = this.props.hideTotalHoursDaily === true;

        // TC detail input fields
        let taskCodeInput = null, dateInput = null, durationInput = null, noteInput = null, changeReasonInput = null;
        let items = [];
        let customTaskList = this.props.customTaskList;

        let vm = this.props.vm; // Expected to be an array of listItem 
        if (vm == null || vm.length == 0) {
            if (customTaskList === false)
                return(
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="ap-duration-grid-container text-center">
                                    No Task Found!
                                </div>
                            </div>
                        </div>
                    </div>
                    );
        } 
        
        this.updateTotal();

        let taskFormControl = this.state.disablePlacementTask?  
                (<FormControl 
                    type="text"
                    inputRef={ref => taskCodeInput = ref}
                    defaultValue={this.state.timecardDetail == null ? null: this.state.timecardDetail.placementTaskCode}
                    disabled={true}>
                </FormControl>)
                :
                (<FormControl componentClass="select"
                    inputRef={ref => taskCodeInput = ref}
                    defaultValue={this.state.timecardDetail == null ? null: this.state.timecardDetail.placementTaskCode}
                    onChange={(evt) => {this.onPlacementTaskChanged(evt.target.value);}}>
                    <option key="" value="">Please select...</option>
                    { this.props.tasks.map(r => <option value={r.taskCode} key={r.taskCode}>{r.taskValue}</option> )}
                </FormControl>);

        var i;
        for(i=0; i<vm.length; i++) {
            const dataItem = vm[i];

            items.push(
                isMobile === true ?

                <div className="row" key={`tr_${i}`}>
                    <div className={`col-xs-12 col-sm-12 ${i % 2 === 0 ? "even" : "odd"}`} key={`tr_sub_${i}`}>
                        <div className="row" >
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-label">
                                    <tbody>
                                    <tr>
                                        <td width="25%">{dataItem.taskCode}</td>
                                        <td width="75%">{dataItem.taskDesc}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-item">
                                    <tbody>
                                    <tr>
                                        {
                                            this.props.weekDays.map(d => 
                                                <th className="ap-col-title" key={d}>
                                                    <div className="dayName">{moment(d).format("ddd")}</div>
                                                    <div className="dayDate">{moment(d).format("M/D")}</div>
                                                </th>)
                                        }
                                    </tr>
                                    <tr className="ap-color-darkgray">
                                        {
                                            [1,2,3,4,5,6,7].map((dayNo) => {
                                                return (
                                                    <td key={`${i}_${dayNo}`}>
                                                        {this.getItemLink(dayNo, dataItem.taskCode, dataItem.taskId, dataItem[`durationDay${dayNo}`])}
                                                    </td>);
                                            })
                                        }
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> 
                </div>
                :
                <tr className="ap-color-darkgray" key={`tr_${i}`}>   
                    <td className="">
                        {dataItem.taskCode}
                    </td>
                    <td className="description">
                        <div className="ap-truncate-text">
                            {dataItem.taskDesc}
                        </div>
                    </td>
                    <td className="text-right total-per-row">
                        {dataItem.durationTotal.toFixed(2)}
                    </td>
                    {
                        [1,2,3,4,5,6,7].map((dayNo) => {
                            return (
                                <td className="text-right ap-duration-grid-item" key={`${i}_${dayNo}`}>
                                    <div>
                                        {this.getItemLink(dayNo, dataItem.taskCode, dataItem.taskId, dataItem[`durationDay${dayNo}`])}
                                    </div>
                                </td>);
                        })
                    }
                </tr> 
                ); 
        }

        if (customTaskList === true && this.props.allowEdit == true) {
            let tasks = this.props.tasks;
            let summary = this.props.vm;
            let options = [];

            for (let j=0; j < tasks.length; j++) {
                // exclude tasks already in summary grid
                if (summary.filter(s => s.taskCode == tasks[j].taskCode).length == 0)
                    options.push(tasks[j]);
            }

            let trTasks = 
                isMobile === true?

                <div className="row" key={`tr_${i}`}>
                    <div className="col-sm-12 col-xs-12">
                        <table className="list-add">
                            <tbody>
                            <tr>
                                <td>
                                    <FormControl componentClass="select" className="ap-no-margin"
                                        onChange={(evt) => {this.onTaskSelected(evt.target.value);}}>
                                        <option key="" value="">{vm == null || vm.length == 0? "Select Task To Log Work Hours..." : "More Task IDs"}</option>
                                        { options.map(r => <option value={r.taskCode} key={r.taskCode}>{r.taskValue}</option> )}
                                    </FormControl>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                :
                <tr className="ap-color-darkgray" key={`tr_${i}`}>
                    <td className="ap-no-padding">
                        <FormControl componentClass="select" className="ap-no-margin"
                            onChange={(evt) => {this.onTaskSelected(evt.target.value);}}>
                            <option key="" value="">{vm == null || vm.length == 0? "Please select..." : "More Task IDs"}</option>
                            { options.map(r => <option value={r.taskCode} key={r.taskCode}>{r.taskValue}</option> )}
                        </FormControl>
                    </td>
                    <td colSpan={9}>
                        { vm == null || vm.length == 0? <i>To log your work hours, please select tasks first.</i> : null }
                    </td>
                </tr>;

            items.push(trTasks);
        }

        return(
            <div className="container">
            {   
                isMobile === true ?

                <div className="row" key="tr_add">
                    <div className="col-xs-12 col-sm-12 ap-duration-grid-mobile"> 
                        {
                            this.props.allowEdit  ? 
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 ap-mb-1">
                                    <Button className="btn primary" onClick={() => this.onDurationClicked(null, null, null)}>Log Work</Button>
                                </div>
                            </div> : null 
                        }
                        {
                            this.props.allowEdit && this.props.enableTcLineCopy  ? 
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 ap-mb-1">
                                    <Button className="btn primary" onClick={this.onOpenTcLineCopy}>Quick Copy</Button>
                                </div>
                            </div> : null 
                        }
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-title" width="100%">
                                    <tbody>
                                    <tr>
                                        <td>Weekly Timecard</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                {
                                    items.length > 0 ? 
                                        
                                        <div className="row" key="tr_head">
                                            <div className="col-xs-12 col-sm-12" key="tr_sub_head"> 
                                                <table className="list-header">
                                                    <tbody>
                                                    <tr>
                                                        <td width="25%">Task ID</td>
                                                        <td width="75%">Task Name</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> : null
                                }
                                {items}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-footer">
                                    <tbody>
                                    <tr>
                                        <td colSpan={7} className="title">
                                            Daily Total
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.totalHoursDaily[0].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[1].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[2].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[3].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[4].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[5].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[6].toFixed(2)}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="ap-duration-grid-container">
                            <div className="row">
                                <div className="col-md-4 col-lg-4">
                                    {
                                        this.props.allowEdit && this.props.enableTcLineCopy? 
                                        <Button className="btn-info ap-fullsize" onClick={this.onOpenTcLineCopy}>Quick Copy</Button> : null 
                                    }
                                </div>
                                <div className="col-md-4 col-lg-4">

                                </div>
                                <div className="col-md-4 col-lg-4">
                                    {
                                        this.props.allowEdit? 
                                        <Button className="btn-info ap-fullsize" onClick={() => this.onDurationClicked(null, null, null)}>Log Work</Button> : null
                                    }
                                </div>
                            </div>
                            <table className="ap-duration-grid">
                                <thead>
                                    <tr>
                                        <td className="ap-col-title ap-h4" colSpan={10}>
                                            Weekly Timecard
                                        </td>
                                    </tr>
                                    <tr className="ap-duration-grid-header" style={{backgroundColor: "unset"}}>
                                        <th className="ap-col-title code">
                                            Task ID
                                        </th>
                                        <th className="ap-col-title description">
                                            Task Name
                                        </th>
                                        <th className="ap-col-title text-center duration">
                                            &#931;
                                        </th>
                                        {
                                            this.props.weekDays.map(d => 
                                                <th className="ap-col-title text-center duration" key={d}>
                                                    <div className="dayName">{moment(d).format("ddd")}</div>
                                                    <div className="dayDate">{moment(d).format("M/D")}</div>
                                                </th>)
                                        }
                                    </tr>
                                </thead>

                                <tbody>
                                    {items}
                                </tbody>

                                <tfoot className={hideTotalHoursDaily ? "ap-hidden" : ""}>
                                    <tr className="ap-duration-grid-footer">   
                                        <td>&nbsp;</td>
                                        <td>Daily Total Hours</td>
                                        <td>&nbsp;</td>
                                        <td className="text-right">{this.state.totalHoursDaily[0].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[1].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[2].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[3].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[4].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[5].toFixed(2)}</td>
                                        <td className="text-right">{this.state.totalHoursDaily[6].toFixed(2)}</td>
                                    </tr>
                                </tfoot>
                            </table>

                            <div className={hideTotalHours ? "ap-hidden" : "ap-bkg-color-gray ap-color-white ap-summary-container"}>
                                <span className="ap-h4">Weekly Total Hours: </span><span>{util.toHrmString(this.state.totalHours)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }

                <Modal show={this.state.showDurationList} onHide={() => this.setState({showDurationList: false})}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Details</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <TaskDurationList vm={this.state.taskDurationList} dayId={this.state.selectedDayId} placementTaskCode={this.state.selectedTaskCode} 
                            onDeletedItem={this.onDeletedItem} onEditItem={this.openTcDetailForm} allowEdit={this.props.allowEdit} />
                    </Modal.Body>
            
                    <Modal.Footer>
                        <div className="row">
                            <div className="col-xs-12 col-md-4">
                                <Button className={this.props.allowEdit ? "btn-info ap-fullsize" : "ap-hidden"} onClick={() => this.openTcDetailForm(null)}>Log Work</Button>
                            </div>
                            <div className="col-xs-12 col-md-4 ap-mt-1"></div>
                            <div className="col-xs-12 col-md-4">
                                <Button className="ap-fullsize" onClick={() => this.setState({showDurationList: false})}>Close</Button>                                 
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showTcDetailForm} onHide={this.closeTcDetailForm}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>{this.state.titleTcDetailForm}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <ControlLabel>Task:<span className="ap-color-red"> *</span></ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                { taskFormControl }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <ControlLabel>Note:</ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                <FormControl componentClass="textarea" rows="2"
                                    inputRef={ref => noteInput = ref}
                                    defaultValue={this.state.timecardDetail == null ? null: this.state.timecardDetail.comment}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <SpecialBillForm timecardLineDetailId={this.state.timecardLineDetailId} offSysId={this.props.offSysId} assignId={this.props.assignId}
                                    ref={node => this.state.specialBillForm = node} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">&nbsp;</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <ControlLabel>Date:<span className="ap-color-red"> *</span></ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                <FormControl componentClass="select"
                                    inputRef={ref => dateInput = ref}
                                    defaultValue={this.state.timecardDetail == null || this.state.timecardDetail.workDate == null ? null: moment(this.state.timecardDetail.workDate).format("M/D/YYYY")}>
                                    {this.props.weekDays.map(d => <option value={moment(d).format("M/D/YYYY")} key={d}>{moment(d).format("dddd, MMMM D, YYYY")}</option> )}
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-2" style={{whiteSpace: "nowrap"}}>
                                <ControlLabel>Time <span style={{fontSize: "12px"}}>(0h 0m)</span>:<span className="ap-color-red"> *</span></ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                <FormControl type="text"
                                    inputRef={ref => durationInput = ref} 
                                    defaultValue={this.state.timecardDetail == null || this.state.timecardDetail.workTime == null ? null: this.state.timecardDetail.workTime.toFixed(2)}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className={this.props.editRequiresReason? "col-xs-12 col-md-2": "ap-hidden"}>
                                <ControlLabel>Reason for Change:<span className="ap-color-red"> *</span></ControlLabel>
                            </div>
                            <div className={this.props.editRequiresReason? "col-xs-12 col-md-10": "ap-hidden"}>
                                <FormControl componentClass="textarea" rows="4" inputRef={ref => changeReasonInput = ref} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <Alert bsStyle="danger" className={this.state.showDialogErrorMessage ? "" : "ap-hidden" }>
                                    <ul>
                                        {this.state.dialogErrorMessage.map(m => <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="row">
                            <div className="col-xs-12 col-md-4">
                                <Button className="btn-info ap-fullsize" onClick={() =>
                                    {
                                        this.saveTcDetailForm({
                                            peopleId: this.props.peopleId,
                                            assignId: this.props.assignId,
                                            offSysId: this.props.offSysId,
                                            timecardId: this.props.timecardId,
                                            userRole: this.props.userRole,
                                            timecardLineDetailId: this.state.timecardLineDetailId,
                                            placementTaskCode: taskCodeInput.value,
                                            placementTaskDetails: this.mapPlacementTaskDetails(this.state.specialBillForm.getValues()),
                                            workDate: dateInput.value,
                                            workTime: util.hmStringToUnit(durationInput.value),
                                            comment: noteInput.value,
                                            changeReason: changeReasonInput.value
                                        });
                                    }}>Save</Button>
                            </div>
                            <div className="col-xs-12 col-md-4 ap-mt-1"></div>
                            <div className="col-xs-12 col-md-4">
                                <Button onClick={this.onCancel} className="ap-fullsize">Cancel</Button>                                 
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                <TimecardLineCopy onCopy={this.onSaveTcLineCopy}
                    timecardId={this.props.timecardId > 0 ? this.props.timecardId : null}
                    ref="tcLineCopy"
                    role={this.props.userRole} />
            </div>
        );
    }
}